import { useToast } from '@chakra-ui/react';
import { useContext } from 'react';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { FilterContext } from '~/contexts/FilterContext/FilterContext';
import { getHomeInvoices } from '~/services';
import { InvoiceView, Pagination } from '~/types';

export function useHomeInvoices(
  page: number,
  options: UseQueryOptions<Pagination<InvoiceView>, unknown> = {},
): UseQueryResult<Pagination<InvoiceView>, unknown> {
  const toast = useToast();
  const { groups, headOffices, branches } = useContext(FilterContext);

  const arrGroups = groups.map(e => e.value);
  const arrHeadOffices = headOffices.map(e => e.value);
  const arrBrancches = branches.map(e => e.value);

  const result = useQuery<Pagination<InvoiceView>, unknown>(
    [page, { arrGroups, arrHeadOffices, arrBrancches }],
    () =>
      getHomeInvoices(page, {
        groups: arrGroups,
        headoffices: arrHeadOffices,
        branches: arrBrancches,
      }),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro ao buscar dados, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
    },
  );
  return result;
}
